<template>
	<div class="site-container">
		<HeaderTemplate />

		<HeaderInfo :currentView="currentView" :breadcrumbItems="breadcrumbItems" :currentPage="currentPage"
			:username="user?.username || 'Utente'" @change-view="changeView"
			@show-new-question-modal="handleShowNewQuestion" />
		<div v-if="showFailedLoginModal">
			<div class="it-example-modal">
				<div class="modal alert-modal show d-block" tabindex="-1" role="dialog" id="modal3"
					aria-labelledby="modal3Title">
					<div class="modal-dialog" role="document">
						<div class="modal-content">
							<div class="modal-header">
								<svg class="icon">
									<use :href="this.baseURL + '/bootstrap-italia/dist/svg/sprites.svg#it-info-circle'">
									</use>
								</svg>
								<h2 class="modal-title h5 " id="modal3Title">Attenzione</h2>
							</div>
							<div class="modal-body">
								<p>Non è stato possibile effettuare l'accesso.<br>Si prega di riprovare più tardi.</p>
							</div>
							<div class="modal-footer">
								<button class="btn btn-primary btn-sm" type="button"
									@click="closeFailedLoginModal">Chiudi</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>



		<!-- Navbar globale -->
		<div>

		</div>

		<!--<section class="it-header-navbar-wrapper-no-login" v-if="$root.user == null">
			<nav class="navbar-prelogin d-flex align-items-center">
				<ul class="nav flex-wrap">
					<li class="nav-item mx-3">
						<a class="nav-link fw-semibold" :class="{ active: activePreLoginView === 'HomeView' }"
							@click="activePreLoginView = 'HomeView'; changeView(views.HomeView)">
							ACCESSO AL SERVIZIO
						</a>
					</li>
					<li class="nav-item mx-3">
						<a class="nav-link fw-semibold"
							:class="{ active: activePreLoginView === 'ListaPareriConsultabili' }"
							@click="activePreLoginView = 'ListaPareriConsultabili'; changeView(views.ListaPareriConsultabili)">
							CONSULTAZIONE PARERI
						</a>
					</li>
				</ul>
			</nav>
		</section>-->

		<!-- Navbar visibile solo se l'utente è loggato -->
		<section class="it-header-navbar-wrapper" v-if="$root.user !== null && $root.user.active">
			<div class="container-xxl">
				<div class="container">
					<div class="col-12">
						<nav class="navbar navbar-expand-lg has-megamenu" aria-label="Navigazione principale">
							<div v-if="$root.user !== null && $root.user.active" class="navbar-collapsable" id="nav1"
								tabindex="-1">
								<Navbar :currentView="currentView" @change-view="changeView"
									@show-new-question-modal="handleShowNewQuestion" />
							</div>
							<div v-else style="height: 3em;"></div>
						</nav>
					</div>
				</div>
			</div>
		</section>

		<!--<ModalView v-model="showNewQuestionModal"
			title="Per quale versione dei contratti pubblici vuoi richiedere un parere?" icon="file-earmark-text"
			size="modal-md">
			<div class="d-flex gap-3 justify-content-center mt-3">
				<button class="btn btn-outline-primary" @click="handleNewQuestionChoice('50/2016')">
					D.lgs. 50/2016
				</button>
				<button class="btn btn-primary" @click="handleNewQuestionChoice('36/2023')">
					D.lgs. 36/2023
				</button>
			</div>
		</ModalView>-->

		<!--<SimpleModal v-model="showNewQuestionModal"
			title="Per quale versione dei contratti pubblici vuoi richiedere un parere?" option1="D.lgs. 50/2016"
			option2="D.lgs. 36/2023" @chose="handleNewQuestionChoice" />-->
		<SimpleModal v-model="showNewQuestionModal"
			title="Per quale versione dei contratti pubblici vuoi richiedere un parere?"
			:buttons="['D.lgs. 50/2016', 'D.lgs. 36/2023']" @chose="handleNewQuestionChoice" />

		<!-- Main content separato 
		<main class="main flex-grow-1" v-show="user !== null">-->
		<main class="main flex-grow-1 padding">
			<component :is="currentView" :elementId="elementId" @change-view="(view, id) => changeView(views[view], id)"
				class="fade-transition"></component>
		</main>





		<FooterTemplate />
	</div>
</template>

<style>
.padding {
	padding-top: 0rem !important;
}

.it-hero-wrapper {
	margin-top: 6.5em;
	min-height: 260px !important;
	background: linear-gradient(-180deg, rgba(0, 102, 204, 1) 0%, rgba(0, 51, 102, 1) 100%);
}

.fade-transition-enter-active,
.fade-transition-leave-active {
	transition: opacity 1s ease, transform 1s ease;
}

.fade-transition-enter-from,
.fade-transition-leave-to {
	opacity: 0;
	transform: translateY(20px);
}

.fade-transition-enter-to,
.fade-transition-leave-from {
	opacity: 1;
	transform: translateY(0);
}

/* Loading modal animations */
.loading-modal {
	animation: fadeIn 0.2s ease-in-out;
}

.site-container {
	max-width: 70%;
	margin: 0 auto;
}

@media (max-width: 1200px) {
	.site-container {
		max-width: 90%;
	}
}

@media (max-width: 768px) {
	.site-container {
		max-width: 95%;
	}
}

.it-header-navbar-wrapper {
	position: relative;
	z-index: 1020;
	margin-top: 0;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
	/* margin-top 0 per posizionarla subito sotto header */
}



@keyframes fadeIn {
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

@keyframes pulse {
	0% {
		opacity: 0.7;
	}

	50% {
		opacity: 1;
	}

	100% {
		opacity: 0.7;
	}
}

@keyframes spin {
	0% {
		transform: scale(0.8);
	}

	50% {
		transform: scale(1.2);
	}

	100% {
		transform: scale(0.8);
	}
}

.main {
	max-width: 100vw;
	flex-grow: 1;
	padding-top: 3rem;
}

.navbar .navbar-collapsable {
	position: relative !important;
	top: 1em !important;
}

@media (max-width: 768px) {
	.main {
		padding-top: 1rem;
	}
}

.it-header-navbar-wrapper-no-login {
	position: relative;
	z-index: 1020;
	margin-top: 0;
	margin-bottom: 0;
	background: #0066cc;
	width: 84rem !important;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);

}

.it-header-navbar-wrapper-no-login:hover {
	transform: translateY(-2px);
	box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
}

.navbar-prelogin {
	height: 60px;
	padding: 0;
}

.navbar-prelogin .nav-link {
	color: white;
	cursor: pointer;
	padding: 0 0.75rem;
	transition: color 0.2s;
}

.navbar-prelogin .nav-link:hover,
.navbar-prelogin .nav-link.active {
	color: #e0e0e0;
	text-decoration: underline;
}
</style>

<script>
import { ref, getCurrentInstance, provide, onMounted, watch } from 'vue';
import HomeView from './components/views/HomeView.vue';
import HeaderTemplate from './components/template/Header.vue'
import FooterTemplate from './components/template/Footer.vue'
import { useRouter, useRoute } from 'vue-router';
import lodash from 'lodash'
import QuestionsView from './components/views/questions/QuestionsView.vue'
import QuestionView from './components/views/questions/QuestionView.vue';
import QuestionDetailView from './components/views/questions/QuestionDetailView.vue'
import Navbar from './components/template/Navbar.vue';
import UserDetailView from './components/views/users/UserDetailView.vue';
import HeaderInfo from './components/template/HeaderInfo.vue';
import ArticlesView from './components/views/ArticlesView.vue';
import ArticleView from './components/views/ArticleView.vue';
import { ContentTree } from './classes/tree.js'
import ModalView from './components/common/ModalView.vue';
import SimpleModal from './components/common/SimpleModal.vue';
import QuestionsByTopicsView from './components/views/questions/QuestionsByTopicsView.vue';
import ListaPareriConsultabili from './components/views/questions/ListaPareriConsultabili.vue';
import ParereView from './components/views/questions/ParereView.vue';
import PareriHighlighted from './components/views/questions/PareriHighlighted.vue';
import HelpDeskPnrr from './components/views/questions/HelpDeskPnrr.vue';

export default {
	name: 'App',
	components: {
		HeaderTemplate,
		FooterTemplate,
		HomeView,
		QuestionsView,
		QuestionView,
		QuestionDetailView,
		Navbar,
		UserDetailView,
		HeaderInfo,
		ArticlesView,
		ArticleView,
		ModalView,
		SimpleModal,
		QuestionsByTopicsView,
		ListaPareriConsultabili,
		ParereView,
		PareriHighlighted,
		HelpDeskPnrr
	},
	setup() {
		const currentView = ref(ListaPareriConsultabili);
		const showFailedLoginModal = ref(false);
		const elementId = ref(undefined);
		let user = ref(null)
		const isAuthenticated = ref(false);
		const authUserData = ref(null);
		const router = useRouter();
		const route = useRoute();
		const currentViewName = ref('HomeView');

		const views = {
			HomeView,
			QuestionsView,
			QuestionView,
			QuestionDetailView,
			UserDetailView,
			HeaderInfo,
			ArticlesView,
			ArticleView,
			ModalView,
			SimpleModal,
			QuestionsByTopicsView,
			ListaPareriConsultabili,
			ParereView,
			PareriHighlighted,
			HelpDeskPnrr
		};

		/**function loadUserInfo() {
			// Ottieni tutti i cookie
			const cookies = getCookies();

			// Non rimuoviamo il token per evitare conflitti con il backoffice
			// localStorage.removeItem('token');
			if (cookies.digitapp_session) {
				//const token = localStorage.setItem('token', cookies.digitapp_session);
				const token = cookies.digitapp_session;

				localStorage.setItem('token', token);


				try {
					const jwtParts = token.split('.');
					//const jwtParts = cookies.digitapp_session.split('.');
					if (jwtParts.length === 3) {
						const payloadBase64 = jwtParts[1];
						const payload = JSON.parse(atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/')));
						if (payload) {
							isAuthenticated.value = true;
							authUserData.value = payload.data;
							user.value = payload
							if (user.value.active) {
								currentView.value = views.QuestionsView;
								currentViewName.value = 'QuestionsView';
								router.replace('/questions');
							}
							else {
								currentView.value = views.UserDataIpaSection;
								currentViewName.value = 'UserDataIpaSection';
								//router.replace(`/users/${user.value.id}`);
							}
						}
					}
				} catch (error) {
					console.error(error)
				}
			}
		}*/

		async function loadUserInfo() {

			const urlParams = new URLSearchParams(window.location.search);

			if (urlParams.get('logout') === 'true') {
				localStorage.removeItem('token');
				window.history.replaceState({}, document.title, window.location.pathname);
				return;
			}
			const code = urlParams.get('code');

			if (code) {
				try {
					const res = await fetch(`${config.VITE_APP_BACKOFFICE_URL}/auth/sso/exchange?code=${encodeURIComponent(code)}`);
					if (res.ok) {
						const data = await res.json();
						if (data?.token) {
							localStorage.setItem('token', data.token);
							window.location.href = window.location.pathname; 
                			return;
						}
					}
				} catch (e) {
					console.error('Exchange SSO code failed:', e);
				} finally {
					window.history.replaceState({}, document.title, window.location.pathname);
				}
			}

			// Leggi il token: prima dal cookie (locale via nginx), poi dal localStorage (Azure post-exchange)
			const cookies = getCookies();
			const token = cookies.digitapp_session || localStorage.getItem('token');

			if (token) {
				localStorage.setItem('token', token);

				try {
					const jwtParts = token.split('.');
					if (jwtParts.length === 3) {
						const payloadBase64 = jwtParts[1];
						const payload = JSON.parse(atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/')));
						if (payload) {
							isAuthenticated.value = true;
							authUserData.value = payload.data;
							user.value = payload;
							if (user.value.active) {
								currentView.value = views.QuestionsView;
								currentViewName.value = 'QuestionsView';
								router.replace('/questions');
							} else {
								currentView.value = views.UserDataIpaSection;
								currentViewName.value = 'UserDataIpaSection';
							}
						}
					}
				} catch (error) {
					console.error(error);
				}
			}
		}

		function refreshUserInfo() {
			//const cookies = getCookies();
			//if (cookies.digitapp_session && localStorage.getItem('token')) {
			if (localStorage.getItem('token')) {
				fetch(`${config.VITE_APP_BACKOFFICE_URL}/auth/refresh`, {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${localStorage.getItem('token')}`
					}
				}).then(response => {
					if (response.ok) {
						return response.json().then(data => {
							if (data && data.token) { // Verifica se il token è presente nella risposta
								const token = data.token; // Usa il token direttamente dalla risposta
								localStorage.setItem('token', token); // Aggiorna il localStorage
								//cookies.digitapp_session = token; // Aggiorna anche il riferimento locale ai cookie

								try { // Facciamo il parsing del JWT
									const jwtParts = token.split('.');
									if (jwtParts.length === 3) {
										const payloadBase64 = jwtParts[1];
										const payload = JSON.parse(atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/')));
										if (payload) {
											isAuthenticated.value = true;
											authUserData.value = payload.data;
											user.value = payload;
										}
									}
								} catch (error) {
									console.error('Errore nel parsing JWT:', error);
									localStorage.removeItem('token');
									window.location.href = `${config.VITE_APP_BACKOFFICE_URL}/auth/sso/login`;
								}
							}
						});
					} else if (response.status === 401) {
						console.log("sessione scaduta");
						localStorage.removeItem('token');
						window.location.href = `${config.VITE_APP_BACKOFFICE_URL}/auth/sso/login`;
					}
				}).catch(error => {
					console.log("sessione scaduta");
				})
			}
		}

		function changeView(view, id, version) {
			console.log("prima", route.fullPath, route.query);
			elementId.value = id || undefined;
			currentView.value = view;
			if (view === views.QuestionsView) {
				//router.push('/questions');
				router.push({ path: '/questions', query: route.query });
			} else if (view === views.QuestionView) {
				router.push('/questions/new');
			} else if (view === views.DashboardView) {
				router.push('/dashboard');
			}
			else if (view === views.QuestionDetailView) {
				router.push(`/questions/${id}`);
			}
			else if (view === views.UserDetailView) {
				router.push(`/users/${id}`);
			}
			else if (view === views.ArticleView) {
				router.push(`/article/${id}${version ? '/' + version : ''}`);
			}

			const viewName = typeof view === 'string'
				? view
				: view?.name;
			localStorage.setItem('currentView', viewName);
			if (id) {
				// Supporto per elementId come oggetto JSON
				if (typeof id === 'object') {
					localStorage.setItem('currentElementId', JSON.stringify(id));
				} else {
					localStorage.setItem('currentElementId', id.toString());
				}
			} else {
				localStorage.removeItem('currentElementId');
			}
			refreshUserInfo();
			console.log("dopo", route.fullPath, route.query)
			window.history.pushState({}, '', '/');
			//router.replace('/');
		}

		const { appContext } = getCurrentInstance()
		const config = appContext.config.globalProperties.$config

		// Funzione per ottenere tutti i cookie come oggetto
		function getCookies() {
			const cookiesObj = {};
			const decodedCookies = decodeURIComponent(document.cookie);

			if (!decodedCookies) return cookiesObj;

			decodedCookies.split(';').forEach(cookie => {
				const parts = cookie.trim().split('=');
				if (parts.length === 2) {
					const name = parts[0].trim();
					const value = parts[1].trim();
					cookiesObj[name] = value;
				}
			});

			return cookiesObj;
		}

		const userInfoPromise = loadUserInfo();
		watch(
			() => route.fullPath,
			(newPath) => {
				const params = route.params;

				if (newPath.includes('/questions/new')) {
					changeView(views.QuestionView);
				} else if (/^\/questions\/\d+/.test(newPath)) {
					const id = params.id || newPath.split('/').pop();
					changeView(views.QuestionDetailView, id);
				} else if (newPath.includes('/questions/topic')) {
					changeView(views.QuestionsByTopicsView);
				} else if (newPath.includes('/questions')) {
					changeView(views.QuestionsView);
				} else if (newPath.includes('/dashboard')) {
					changeView(views.DashboardView);
				} else if (/^\/article\/\d+/.test(newPath)) {
					// route article con optional version
					const segments = newPath.split('/');
					const articleId = segments[2];
					const version = segments[3] || undefined;
					changeView(views.ArticleView, articleId, version);
				} else if (newPath.includes('/articles')) {
					changeView(views.ArticlesView);
				} else if (newPath.includes('index.html')) {
					const searchParams = new URLSearchParams(window.location.search);
					const article = searchParams.get('article');
					const version = searchParams.get('version');
					if (article) {
						router.push({ name: 'article', params: { article: article, version: version || undefined } });
					}
				}
			}
		);

		return {
			currentView,
			userInfoPromise,
			changeView,
			loadUserInfo,
			config,
			showFailedLoginModal,
			user,
			elementId,
			views
		};
	},
	/**watch: {
		'$route.fullPath'(to, from) {
			this.updateLocation()
		}
	},*/

	async created() {
		//load tree contents
		await this.fetchDlgs();
		await this.fetchContents();
		await this.fetchAccessMessages();
	},
	/**async mounted() {
		if (window.location.pathname === '/') {
			const savedView = localStorage.getItem('currentView');
			const savedId = localStorage.getItem('currentElementId');

			if (savedView && this.views[savedView]) {
				this.currentView = this.views[savedView];
				this.elementId = savedId ? JSON.parse(savedId) : undefined;
			}
		}
		if (window.location.search.includes('login=failed')) {
			this.showFailedLoginModal = true;
		}
		this.updateLocation();
	},*/
	async mounted() {
		if (window.location.pathname === '/') {
			const savedView = localStorage.getItem('currentView');
			const savedId = localStorage.getItem('currentElementId');
			if (savedView && this.views[savedView]) {
				this.currentView = this.views[savedView];
				this.elementId = savedId ? JSON.parse(savedId) : undefined;
			}
		}
		if (window.location.search.includes('login=failed')) {
			this.showFailedLoginModal = true;
		}
		// Se c'è un ?code= SSO, aspetta il completamento dell'exchange prima di updateLocation()
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.get('code')) {
			await this.userInfoPromise; // attende la promise già avviata in setup(), non la richiama
		}
		this.updateLocation();
	},
	data() {
		return {
			showNewQuestionModal: false,
			modalTargetView: null,
			contents: undefined, //this.getContents(),
			contentTree: undefined, //new ContentTree(lodash.cloneDeep(this.contents)),
			contentsLoading: false, // Flag to track if contents are being loaded
			articleLoading: false, // Flag to track if an article is being loaded (global state)
			currentArticleRequest: null, // Store the current article request promise
			dlgs: {},
			baseURL: this.config.VITE_APP_BASE_URI + this.config.VITE_APP_BASE_PATH,
			article: "",
			section: "",
			version: "",
			breadcrumbData: {
				section: undefined,
				article: undefined,
			},
			accessMessages: {
				request_limit_reached_message: '',
				registration_accepted_message: '',
				registration_creation_message: '',
				registration_rejected_message: ''
			},
			breadcrumbData: {
				section: undefined,
				article: undefined,
			},
			activePreLoginView: 'ListaPareriConsultabili',
		}
	},
	methods: {
		goTo(viewName) {
			this.changeView(this.views[viewName]);
			this.activePreLoginView = viewName;
		},
		handleNewQuestionChoice(version) {
			this.showNewQuestionModal = false;
			if (version.includes('50/2016')) {
				// naviga ad altra vista
				this.changeView(this.views.QuestionsByTopicsView);
				//this.$emit('change-view', 'QuestionsByTopicsView');
			} else {
				// rimani sulla stessa pagina (ArticlesView)
			}
		},
		handleShowNewQuestion(view) {
			console.log('Evento intercettato!', view)
			this.showNewQuestionModal = true
			this.modalTargetView = view
			this.changeView(view);

		},
		closeFailedLoginModal() {
			this.showFailedLoginModal = false;
			const url = new URL(window.location);
			url.searchParams.delete('login');
			window.history.replaceState({}, document.title, url.toString());
		},
		updateLocation() {
			/**let urlObj = (new URL(window.location))
			const params = new URLSearchParams(urlObj.search);
			if (!params.get('section') && !params.get('article') && !params.get('version')) {
				this.changeView(HomeView, null, null, null)
			}
			if (params.get('section')) {
				this.changeView(SectionView, params.get('section'), params.get('article'), params.get('version'))
			}
			if (params.get('article')) {
				this.changeView(ArticleView, params.get('section'), params.get('article'), params.get('version'));
			}*/
			const urlObj = new URL(window.location);
			const params = new URLSearchParams(urlObj.search);

			// Controlla se l'utente è loggato
			const isUserLoggedIn = this.user !== null;

			// Caso: utente NON loggato → ArticleView
			if (!isUserLoggedIn) {
				this.changeView(this.views.ListaPareriConsultabili);
				return;
			}
		},
		loadBreadcrumb(node) {
			if (node === null) {
				this.breadcrumbData.section = null
				this.breadcrumbData.article = null
				return
			}
			if (node.type == "section") {
				this.breadcrumbData.section = node
				this.breadcrumbData.article = null
			} else {
				this.breadcrumbData.article = node
				this.breadcrumbData.section = null
			}
		},
		async fetchContents() {
			// Se i contenuti sono già caricati o in fase di caricamento, non fare nulla
			if (this.contentTree || this.contentsLoading) {
				return;
			}

			// Imposta il flag di caricamento
			this.contentsLoading = true;

			try {
				console.log('Fetching contents...');
				const response = await fetch(this.config.VITE_APP_BACKOFFICE_URL + '/contents')
				if (response.ok) {
					const data = await response.json()
					this.contents = data.data
					if (data.status) {
						this.contentTree = new ContentTree(lodash.cloneDeep(this.contents))
						console.log('Contents loaded successfully');
					}
				}
			} catch (error) {
				console.error('Error loading contents:', error);
				//TODO: aggiungi un avviso di errore
			} finally {
				// Reimposta il flag di caricamento
				this.contentsLoading = false;
			}
		},
		async fetchAccessMessages() {
			const response = await fetch(this.config.VITE_APP_BACKOFFICE_URL + "/use-requests/access-messages")
			if (response.ok) {
				const data = await response.json()
				this.accessMessages = data
			}
		},
		async fetchDlgs() {
			const response = await fetch(this.config.VITE_APP_BACKOFFICE_URL + "/versions")
			if (response.ok) {
				const data = await response.json()
				this.dlgs = {};
				if (data.status) {
					data.data.versions.forEach(dlg => {
						this.dlgs[dlg.id] = dlg;
					});
				}
			}
			//TODO: aggiungi un avviso di errore
		},
		updateContentTree() { //notifica Vue dell'aggiornamento dei nodi del contentTree
			this.contentTree.nodes = [...this.contentTree.nodes];
		},
		// Metodo per caricare un articolo una sola volta, anche se richiesto da più componenti
		async fetchArticle(articleId, versionId = '', validityDate = null) {
			// Se c'è già una richiesta in corso per lo stesso articolo, restituisci quella
			if (this.articleLoading && this.currentArticleRequest) {
				return this.currentArticleRequest;
			}

			this.articleLoading = true;

			// Costruisci l'URL
			let url = `${this.config.VITE_APP_BACKOFFICE_URL}/article/${articleId}/${versionId}`;
			if (validityDate) {
				url += `?validity_date=${validityDate}`;
			}

			// Crea e memorizza la promise
			this.currentArticleRequest = fetch(url)
				.then(response => {
					if (response.ok) {
						return response.json();
					}
					throw new Error('Failed to fetch article');
				})
				.catch(error => {
					console.error('Error fetching article:', error);
					throw error;
				})
				.finally(() => {
					this.articleLoading = false;
				});

			return this.currentArticleRequest;
		},
	}
}
</script>